import React from "react";

const ColumnSelector = ({ columns, selectedColumns, setSelectedColumns }) => {
  const handleColumnToggle = (column) => {
    setSelectedColumns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };

  return (
    <div className="space-y-2">
      {columns.map(({ key, label }) => (
        <label key={key} className="flex items-center space-x-2">
          <input
            type="checkbox"
            defaultChecked={selectedColumns[key]}
            onChange={() => handleColumnToggle(key)}
            className="form-checkbox h-5 w-5 text-blue-600 rounded-md"
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
};

export default ColumnSelector;
